module.exports = __webpack_public_path__ + "img/KW.8b211fe0.svg";